import { Box, Button, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { BlogCard } from './BlogCard';
import { frontendSettingsAtom } from '../../../atoms/FrontendSettings';
import { Blog } from '../../../interfaces/Blog/Blog';
import { useThemeColor } from '../hooks/useThemeColor';
import { useIsMobile } from '../hooks/useIsMobile';
import { getBlogs } from '../../../api/Blog';
import { EditableStyleWrapper } from '../StyleEditor/EditableStyleWrapper';

export const Blogs = () => {
  const settings = useRecoilValue(frontendSettingsAtom);

  const [blogs, setBlogs] = useState<Blog[]>([]);

  const { primary, secondary, ternary } = useThemeColor();
  const isMobile = useIsMobile();

  useEffect(() => {
    getBlogs()
      .then((b) => setBlogs(b))
      .catch((err) => toast.error(err.message));
  }, []);

  return (
    <EditableStyleWrapper path='blogsWidgetSettings.rootStyle'>
      <Box
        sx={{
          width: '100%',
          p: isMobile ? 3 : 10,
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
          gap: 2.5,
          backgroundColor: settings.settingsV1.storefront_blogs_color,
          boxSizing: 'border-box',
          ...settings.settingsV2?.blogsWidgetSettings?.rootStyle,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5,
            justifyContent: 'center',
          }}
        >
          <EditableStyleWrapper path='blogsWidgetSettings.titleStyle'>
            <Typography
              sx={{
                color: ternary,
                fontSize: '36px',
                fontWeight: 600,
                ...settings.settingsV2?.blogsWidgetSettings?.titleStyle,
              }}
            >
              {settings.settingsV1.blog_text}
            </Typography>
          </EditableStyleWrapper>

          <EditableStyleWrapper path='blogsWidgetSettings.subtitleStyle'>
            <Typography
              sx={{
                color: ternary,
                width: 250,
                fontSize: '16px',
                fontWeight: 500,
                ...settings.settingsV2?.blogsWidgetSettings?.subtitleStyle,
              }}
            >
              {settings.settingsV1.blog_description ||
                'Yeni blog yazılarımıza göz atın!'}
            </Typography>
          </EditableStyleWrapper>

          <EditableStyleWrapper path='blogsWidgetSettings.viewAllButtonStyle'>
            <Button
              sx={{
                fontWeight: 700,
                fontSize: '13px',
                padding: '8px 15px',
                color: secondary,
                backgroundColor: primary,
                transition: 'background-color 0.3s ease',
                textTransform: 'none',
                width: 'fit-content',
                '&:hover': {
                  backgroundColor: ternary,
                },
                ...settings.settingsV2?.blogsWidgetSettings?.viewAllButtonStyle,
              }}
            >
              Tüm İçerikleri Gör
            </Button>
          </EditableStyleWrapper>
        </Box>

        <Box sx={{ ml: 'auto' }} />

        {isMobile ? (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              gap: 2.5,
              overflowX: 'auto',
              alignItems: 'stretch', // ensures children stretch vertically
            }}
          >
            {blogs.slice(0, 3).map((blog, i) => (
              <Box key={i} sx={{ minWidth: 250, display: 'flex' }}>
                <BlogCard blog={blog} sx={{ flex: 1 }} />
              </Box>
            ))}
          </Box>
        ) : (
          blogs.slice(0, 3).map((blog, i) => <BlogCard key={i} blog={blog} />)
        )}
      </Box>
    </EditableStyleWrapper>
  );
};
